const googleMapsAPI = 'AIzaSyCPUzj-bn5yMMn1pA5sDYf5UhG2qdwYAnI';

export default googleMapsAPI;